import { isAbortRequestError, resolveErrorMessages } from '@sigma-frontend-libs/commons'

import store from '@/store'
import { getTranslate } from '@/utils'

/**
 * Приводит ошибки запроса к элементам, пригодным для показа пользователю.
 *
 * Выбор текста выполняет `resolveErrorMessages` из commons. Отменённые запросы
 * пропускаются, в режиме разработки перед элементами ошибки добавляется элемент
 * `console` с сырым телом.
 *
 * @param {Array|object} errors Ошибка запроса или массив ошибок.
 * @returns {Array} Элементы для `globalErrorHandler`.
 */
export function globalErrorProcessor(errors = []) {
  if (!Array.isArray(errors)) {
    errors = [ errors ]
  }

  const result = []

  for (const source of errors) {
    if (isAbortRequestError(source)) {
      continue
    }

    if (process.env.NODE_ENV === 'development') {
      result.push({
        type: 'console',
        raw: source
      })
    }

    result.push(...resolveErrorMessages(source, getTranslate))
  }

  return result
}

/**
 * Возвращает текст ошибки для снекбара.
 *
 * @param {string|undefined} translate Готовый текст ошибки.
 * @param {string|undefined} message Сообщение бэкенда.
 * @returns {string} Текст для показа пользователю.
 */
function getErrorTextForSnackbar(translate, message) {
  if (translate) {
    return translate
  }

  if (message) {
    return message
  }

  return getTranslate('errors.validation.types.serverNotAvailable')
}

/**
 * Показывает пользователю готовые элементы ошибок.
 *
 * @param {Array|object} errors Элементы от `globalErrorProcessor`.
 */
export function showErrorMessages(errors = []) {
  if (!Array.isArray(errors)) {
    errors = [ errors ]
  }

  for (const error of errors) {
    const { type, translate, message } = error
    switch (type) {
      case 'console': {
        console.error(error.raw)
        break
      }

      case 'field':
      case 'snackbar':
      default: {
        store.dispatch('notifications/addSnackbar', {
          text: getErrorTextForSnackbar(translate, message),
          type: 'error'
        })
        break
      }
    }
  }
}

/**
 * Разбирает ошибку запроса и показывает её пользователю.
 *
 * @param {Array|object} errors Ошибка запроса или массив ошибок.
 */
export function globalErrorHandler(errors = []) {
  showErrorMessages(globalErrorProcessor(errors))
}
